// eBay Sell Fulfillment API v1 — coverage. Grounded in
// server/src/channels/ebay/fulfillment.js. Order-level refund without a return.
export default {
  api: 'eBay Sell Fulfillment API v1',
  blurb:
    'Order-level refund without requiring a return (issue_refund). Auth: the user OAuth access token (getAccessToken()) as "Authorization: Bearer <token>" — needs the read-write sell.fulfillment scope (NOT .readonly). Gated: reads need EBAY_POST_ORDER_READ_ENABLED (shared master switch); the write needs EBAY_POST_ORDER_WRITE_ENABLED. Nothing persisted.',
  endpoints: [
    {
      verb: 'POST', path: '/order/{orderId}/issue_refund', fn: 'issueOrderRefund()', rw: 'write',
      params: [
        { p: 'orderId (path)', req: 'required', send: 'gated', val: 'eBay order id' },
        { p: 'reasonForRefund', req: 'required', send: 'gated', val: 'ReasonForRefundEnum (e.g. BUYER_RETURN, ITEM_NOT_AS_DESCRIBED)' },
        { p: 'comment', req: 'optional', send: 'gated', val: 'Free-text note sent with the refund' },
        { p: 'orderLevelRefundAmount', req: 'optional', send: 'gated', val: '{ currency: USD, value: <amount> }' },
      ],
      fields: [
        { f: 'refundId / refundStatus', pull: false, db: null, note: 'Response returned by the client but the executor uses success/failure only; body not consumed', badge: 'gate' },
      ],
    },
  ],
}
